import { Pipe, PipeTransform } from '@angular/core';

enum SuffixEng {
  st = 'st',
  nd = 'nd',
  rd = 'rd',
  th = 'th',
}

type OrdinalInput = number | string | null | undefined;

@Pipe({ name: 'baseOrdinalSuffixPipe' })
export class BaseOrdinalSuffixPipe implements PipeTransform {
  transform(value: OrdinalInput): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const num = typeof value === 'string' ? Number(value) : value;

    if (!Number.isFinite(num) || !Number.isInteger(num)) {
      return String(value);
    }

    const abs = Math.abs(num);
    const lastTwo = abs % 100;
    let suffix: SuffixEng;

    if (lastTwo >= 11 && lastTwo <= 13) {
      suffix = SuffixEng.th;
    } else {
      switch (abs % 10) {
        case 1:
          suffix = SuffixEng.st;
          break;
        case 2:
          suffix = SuffixEng.nd;
          break;
        case 3:
          suffix = SuffixEng.rd;
          break;
        default:
          suffix = SuffixEng.th;
      }
    }

    return `ordinalSuffix.${suffix}`;
  }
}
